/* eslint-disable */
if (typeof window !== 'undefined' && !Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
/* eslint-enable */